import type { AppBillingInterval } from '../billingPlans';

interface BillingIntervalToggleProps {
  value: AppBillingInterval;
  onChange: (interval: AppBillingInterval) => void;
  disabled?: boolean;
}

const OPTIONS: Array<{ interval: AppBillingInterval; label: string }> = [
  { interval: 'MONTHLY', label: 'Monthly' },
  { interval: 'ANNUAL', label: 'Annual' },
];

export function BillingIntervalToggle({
  value,
  onChange,
  disabled = false,
}: BillingIntervalToggleProps) {
  return (
    <div
      role="group"
      aria-label="Pro billing interval"
      className="inline-flex rounded-lg border border-border bg-background p-1"
    >
      {OPTIONS.map((option) => {
        const selected = value === option.interval;
        return (
          <button
            key={option.interval}
            type="button"
            data-testid={`billing-interval-${option.interval.toLowerCase()}`}
            aria-pressed={selected}
            disabled={disabled}
            onClick={() => onChange(option.interval)}
            className={`rounded-md px-3 py-1.5 text-sm font-medium disabled:opacity-50 ${
              selected ? 'bg-primary text-primary-foreground' : 'text-muted-foreground hover:text-foreground'
            }`}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
